<template>
  <main>
    <!-- Contenido Principal -->
    <div class="side-page-container background-opacity">
      <!-- Header -->
      <!-- <header class="py-5 bg-about" style="height: 100dvh; width: 100dvw">
          <div class="text-center">
            <img class="img-fluid mb-3" src="./../../images/logos/HomeLogo.png" alt="..." style="width: 60vh; padding-top: 15vh" />
            <h1 class="questrial-regular text-white oswald-font">About us</h1>
          </div>
        </header> -->
      <div class="row justify-content-center p-5">
        <div class="col-md-10 about-section">
          <div class="about-header">
            <p class="text-title-neon orbitron-font title-main">Welcome to <em style="font-size: inherit">AI Alpha Analytics</em></p>
            <div class="about-info center">
              <h4 class="text-white oswald-font description">AI Alpha Analytics specializes in creating innovative AI-driven solutions, enabling organizations to excel in an increasingly digital world by leveraging the latest advancements in artificial intelligence and software development.</h4>
            </div>
          </div>
          <div class="about-info right">
            <p class="text-subtitle orbitron-font subtitle">Mission & Focus:</p>
            <h4 class="text-white oswald-font description">Our mission is to unlock AI's full potential to address complex challenges, enhance operational efficiency, and drive transformative growth, ensuring businesses stay ahead in a competitive market.</h4>
          </div>
          <div class="about-info left">
            <p class="text-subtitle orbitron-font subtitle">Comprehensive Offerings:</p>
            <h4 class="text-white oswald-font description">We offer a broad range of cutting-edge software solutions, including predictive analytics, automation tools, and advanced data insights, designed to meet the unique and diverse needs of different industries.</h4>
          </div>
          <div class="about-info right">
            <p class="text-subtitle orbitron-font subtitle">Partnership & Excellence</p>
            <h4 class="text-white oswald-font description">AI Alpha Analytics is committed to building strong, long-lasting partnerships based on trust, delivering scalable, reliable, and innovative solutions that not only meet current business demands but also anticipate future technological opportunities.</h4>
          </div>
        </div>
      </div>
      <hr class="separador" />
      <!--Contenido principal-->
      <div
        class="p-2"
        :class="{
          'd-flex flex-column align-items-center justify-content-center text-center': isMobile,
        }"
      >
        <div class="background-transparent" id="projects">
          <div class="px-4 px-lg-5">
            <!-- Featured Project Row-->
            <!-- <div class="row gx-0 mb-4 mb-lg-5 align-items-center">
                <div class="col-xl-8 col-lg-7"><img class="img-fluid mb-lg-0" src="/images/logos/BarLogo.png" alt="..." style="width: 80%" /></div>
                <div class="col-xl-4 col-lg-5">
                  <div class="featured-text text-center">
                    <h2 class="text-title orbitron-font">Our Team</h2>
                    <h4 class="text-white oswald-font my-3 mx-0">
                      We seek to lead AI-driven innovation with an <span class="text-neon oswald-font">interdisciplinary team of experts in software engineering, civil engineering, astronomy, healthcare, and AI.</span> This diversity allows them to develop comprehensive, tailored solutions for complex challenges across various industries.
                      <span class="text-neon oswald-font">With AI Alpha Analytics, clients not only adapt to the digital era but lead it through this diverse expertise.</span>
                    </h4>
                  </div>
                </div>
              </div> -->
            <!-- Project One Row-->
            <div class="row gx-0 mb-5 mb-lg-0 justify-content-center background-transparent">
              <div class="col-lg-6 d-flex justify-content-center align-items-center">
                <img class="img-fluid px-4 py-4 about-img" src="/images/logos/BarLogo.png" alt="..." />
              </div>
              <div class="col-lg-6">
                <div class="background-transparent text-center h-100 project">
                  <div class="d-flex h-100">
                    <div class="w-100 my-auto text-center text-lg-left">
                      <h2 class="text-title my-4">Our Team</h2>
                      <h4 class="text-white oswald-font text-justify" :class="!isMobile ? 'px-5' : ''">
                        We seek to lead AI-driven innovation with an
                        <span class="text-neon oswald-font">interdisciplinary team of experts in software engineering, civil engineering, astronomy, healthcare, and AI.</span>
                        This diversity allows them to develop comprehensive, tailored solutions for complex challenges across various industries.
                        <span class="text-neon oswald-font">With AI Alpha Analytics, clients not only adapt to the digital era but lead it through this diverse expertise.</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Project Two Row-->
            <div class="row gx-0 justify-content-center">
              <div v-if="!isMobile" class="col-lg-6">
                <img class="img-fluid px-4 py-4 commitment-desktop" src="/images/Commitment.png" alt="..." />
              </div>
              <div v-else class="col-lg-6">
                <img class="img-fluid px-4 py-4 commitment-mobile" src="/images/CommitmentMobile.png" alt="..." />
              </div>
              <div class="col-lg-6 order-lg-first">
                <div class="background-transparent text-center h-100 project">
                  <div class="d-flex h-100">
                    <div class="w-100 my-auto text-center text-lg-right">
                      <h2 class="text-title justify-text-center my-4">Our Commitment</h2>
                      <h4 class="text-white oswald-font text-justify px-5">
                        AI Alpha Analytics
                        <span class="text-neon">drives innovation</span> with advanced AI-powered software solutions, aiming to push technological boundaries. We create intelligent, adaptable software that not only tackles today’s challenges but also
                        <span class="text-neon"> positions clients to lead in a rapidly changing digital world.</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin.js';
export default {
  mixins: [GlobalMixin],
  name: 'About',
  data() {
    return {
      isMobile: 800,
    };
  },
  created() {},
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 800;
      console.log('isMobile:', this.isMobile);
    },
  },
};
</script>

<style lang="scss" scoped>
.about-section {
  .title-main {
    font-size: 4vh;
  }

  .subtitle {
    font-size: 4vh;
    text-align: inherit;
  }

  .description {
    text-align: inherit;
  }

  .about-info {
    margin-bottom: 2dvh;

    &.center {
      text-align: center;
      margin-inline: 2.5dvw;
      margin-block: 0;
    }

    &.left {
      text-align: left;
      .description {
        margin-right: 15dvw;
      }
    }

    &.right {
      text-align: right;
      .description {
        margin-left: 15dvw;
      }
    }
  }

  .about-header {
    padding-bottom: 5dvh;
  }

  @media (max-width: 800px) {
    .about-header {
      padding-bottom: 4dvh;
    }

    .about-info {
      &.center {
        margin-inline: 0;
        text-align: justify;
      }

      &.left {
        .description {
          margin-right: 5dvw;
          text-align: justify;
        }
      }

      &.right {
        .description {
          margin-left: 5dvw;
          text-align: justify;
        }
      }
    }
  }
}
</style>
